import {IStateProps} from './model';
import {useStyles} from '../../hooks/styles';
import {TouchableOpacity, View} from 'react-native';
import React from 'react';
import {useIsDesktop} from '../../hooks/useIsDesktop';
import {images} from '../../../assets/icons';
import {Text} from '../text';
import {createStyles} from './style';

export default ({
  expanded,
  onPress,
  title,
  children,
  contentCustomStyle,
  wrapCustomStyle,
  variant,
  index,
}: IStateProps) => {
  const styles = useStyles((helper) => createStyles(helper, variant), [variant]);
  const isDesktop = useIsDesktop();
  const {Left: Arrow} = images;

  const renderExtraByVariant = () => {
    if (variant === 'filled') {
      return (
        <>
          <View style={[styles.arrow, expanded && styles.arrowActive]}>
            <Arrow width={20} height={20} color={styles.arrow.color} />
          </View>
        </>
      );
    }

    return null;
  };

  return (
    <View style={[styles.wrap, wrapCustomStyle]}>
      <TouchableOpacity
        testID={`accordion-button-${index}-id`}
        style={styles.touchableHeaderZone}
        activeOpacity={isDesktop ? 1 : 0.5}
        onPress={onPress}>
        <View style={styles.header}>
          <Text testID={`accordion-title-${index}-id`} style={styles.headerText}>
            {title}
          </Text>
          {renderExtraByVariant()}
        </View>
      </TouchableOpacity>
      {expanded ? (
        <View style={[styles.content, contentCustomStyle]} testID={`accordion-body-${index}-id`}>
          {children}
        </View>
      ) : null}
    </View>
  );
};
